export default __webpack_public_path__ + "fonts/SohneBreit-Dreiviertelfett.woff!static";